import { useMessages } from "../language/language"
import { serverPlayJoin } from "utils/server"
import LoginComponent from "../components/login-component"
import { serverRequestErrorReducer, studentJoinedReducer } from "play/reducers"
import { usePlayState } from "play/hooks/use-play-state"
import playEnvironment from "play/play-environment"
import { useEffect, useRef } from "react"

function GameCodeFrame() {
  const { gameCode, modifyState } = usePlayState()
  const msg = useMessages()
  const isLoading = useRef(false)

  function handleUpdateGameCode(gameCode: string) {
    modifyState((state) => {
      playEnvironment.oldGameCode = gameCode
      state.gameCode = gameCode
    })
  }

  async function handleGameCodeEntered() {
    if (isLoading.current) return
    isLoading.current = true

    try {
      const resp = await serverPlayJoin({ gameCode })
      modifyState((state) => {
        isLoading.current = false
        studentJoinedReducer(state, resp)
      })
    } catch (e) {
      modifyState((state) => {
        isLoading.current = false
        serverRequestErrorReducer(state, e)
      })
    }
  }

  useEffect(() => {
    modifyState((state) => {
      state.serverError = null
      state.joinError = null
      state.serverErrorData = null
    })
  }, [])

  return (
    <LoginComponent
      type="gamecCode"
      inputSize="small"
      label={msg.gameCode_label}
      value={gameCode}
      isEnabled={!isLoading.current}
      actionButtonText={msg.gameCode_action}
      onInputChanged={handleUpdateGameCode}
      onActionClicked={handleGameCodeEntered}
    />
  )
}

export default GameCodeFrame
